import {Injectable, signal} from '@angular/core';
import {ModalStates} from "../../types/table-types/modal-states.types";

@Injectable({
  providedIn: 'root'
})
export class ModalStatesService {
  private _modalStates = signal<ModalStates>({});
  public modalStates = this._modalStates.asReadonly();
  private _isBloggerModalOpen = signal(false);

  public openModal(modalName: string): void {
    this._modalStates.update(states => ({
      ...states,
      [modalName]: true
    }));

    modalName === 'blogger-profile' && this.openBloggerModalOpen();
  }

  public closeModal(modalName: string): void {
    this._modalStates.update(states => {
      const newStates = { ...states };
      delete newStates[modalName];
      return newStates;
    });
  }

  public hasOpenModals(): boolean {
    return !!Object.keys(this.modalStates()).length;
  }

  public isBloggerProfileOpen(): boolean {
    return this._isBloggerModalOpen() && !this.hasOpenModals();
  }

  public closeBloggerModalOpen(): void {
    this._isBloggerModalOpen.set(false);
  }

  private openBloggerModalOpen(): void {
    this._isBloggerModalOpen.set(true);
  }
}
